import styled from 'styled-components';


export const AtPartOuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10rem auto 5rem auto;
`;


export const AtPartTopH3 = styled.h3`
  font-size: 20px;
  margin-bottom: 15px;
  font-weight: 500;
`;

export const AtPartH2 = styled.h2`
  font-size: 28px;
  color: var(--maindark);
  font-weight: 500;
  letter-spacing: 1px;
  margin: 2rem 0 1rem 0;

  @media screen and (min-width: 768px) {
    font-size: 30px;
    margin: 2rem 0 1rem 0;
  }

  @media screen and (min-width: 1024px) {
    font-size: 36px;
    margin: 2rem 0 1rem 0;
  }
`;

export const UnderlineAtPartner = styled.div`
  width: 100px;
  height: 4px;
  background-color: #f9f900;
  margin: 0 auto 3rem auto;

  @media (min-width: 768px) {
    width: 110px;
  }

  @media (min-width: 1024px) {
    width: 120px;
  }
`;


export const TwoSectionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  max-width: 900px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const InnerColumn = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
`;


export const FullWidthDiv = styled.div`
  grid-column: span 2;
  max-width: 900px;
  margin-top: 10px;
  padding: 20px;
`;


export const SectionH4 = styled.h4`
  font-size: 20px;
  margin-bottom: 15px;
  font-weight: 500;
`;


export const SectionP = styled.p`
  font-size: 16px;
  line-height: 1.5;
  color: var(--maindark);
  margin-bottom: 15px;
   white-space: pre-line;
`;